<template>
  <div class="modalBackground">
    <div class="MessageArchive">
      <h2>MULTIMESSAGE TEMPLATES</h2>
      <p class="helperText" v-if="archivedMessages.length > 0">
        Please select from the following:
      </p>
      <div class="archiveList" v-if="archivedMessages.length > 0">
        <div
          class="listItem"
          v-for="(message, index) in paginatedData"
          :key="message.documentID"
        >
          <div class="selectedBorder" v-if="index + 1 == selectedMessage"></div>
          <div class="messageContent">
            <p>{{ message.messageType }}</p>
            <p>{{ message.createdAt.slice(0, 10) }}</p>
            <p class="messageContent__subject" v-if="message.subjectContent">
              {{ message.subjectContent.slice(0, 15) }}
            </p>
            <button-global
              text="VIEW"
              size="small"
              type="positive"
              @eventPassed="
                openMessageContent(
                  message.messageContent,
                  message.subjectContent,
                  message.messageType
                )
              "
            ></button-global>
          </div>
          <button-global
            :text="index + 1 === selectedMessage ? 'SELECTED' : 'SELECT'"
            size="small"
            type="positive"
            @eventPassed="
              selectFromArchive(
                index + 1,
                message.messageContent,
                message.subjectContent,
                message.messageType
              )
            "
          ></button-global>
          <button-global
            text="DELETE"
            size="small"
            type="negative"
            :disabled="index + 1 !== selectedMessage"
            @eventPassed="showApproveModal = true"
          ></button-global>
        </div>
      </div>
      <div class="archiveList centerFlex" v-if="archivedMessages.length === 0">
        <h3>NO TEMPLATES</h3>
        <p>Use the "SAVE TEMPLATE" button to view them here.</p>
      </div>
      <div class="pagination-bar-wrapper" v-if="showPagination">
        <button-global
          text="PREVIOUS"
          type="negative"
          size="small"
          @eventPassed="prevPage"
          :disabled="pageNumber == 0"
        ></button-global>
        <div class="pagination-bar-inner-wrapper">
          <div
            v-for="index in pageCount"
            class="pagination-item"
            :class="{ 'pagination-item-active': index - 1 === pageNumber }"
            :key="index"
            @click="pageNumber = index - 1"
          >
            {{ index }}
          </div>
        </div>
        <button-global
          text="NEXT"
          type="positive"
          size="small"
          @eventPassed="nextPage"
          :disabled="pageNumber >= pageCount - 1"
        ></button-global>
      </div>
      <div class="buttonRow">
        <button-global
          text="CANCEL"
          type="negative"
          @eventPassed="closeArchive"
        ></button-global>
        <button-global
          text="USE"
          type="positive"
          @eventPassed="useFromArchive"
          :disabled="!selectedMessage"
          v-if="archivedMessages.length > 0"
        ></button-global>
        <button-global
          text="GET ALL TEMPLATES"
          size="medium"
          type="neutral"
          @eventPassed="loadAllLogs"
          v-if="showloadMoreButton && archivedMessages.length > 4"
        ></button-global>
      </div>
    </div>
    <transition name="fadeInModal">
      <approve-modal
        @yes="deletePermanently"
        @no="showApproveModal = false"
        v-if="showApproveModal"
      >
        <p slot="text">Are you sure you want to delete this item?</p>
      </approve-modal>
    </transition>
    <transition name="fadeInModal">
      <view-multi-message
        @closeContentModal="viewMessageContent = false"
        :renderContent="messageContent"
        :renderSubject="messageSubject"
        v-if="viewMessageContent"
      ></view-multi-message>
    </transition>
    <fetching-loader
      displayType="displayFixed"
      v-if="fetchingDataLoader"
    ></fetching-loader>
  </div>
</template>

<script>
import ButtonGlobal from "@/components/GlobalComponents/ButtonGlobal";
import ApproveModal from "@/components/GlobalComponents/ApproveModal";
import FetchingLoader from "@/components/GlobalComponents/FetchingLoader";
import ViewMultiMessage from "./ViewMultiMessage";
import { firestore } from "@/firebase";

export default {
  name: "MultiMessageArchive",
  components: {
    ButtonGlobal,
    ApproveModal,
    FetchingLoader,
    ViewMultiMessage,
  },
  data() {
    return {
      archivedMessages: [],
      selectedMessage: null,
      fetchingDataLoader: true,
      showApproveModal: false,
      totalArchivedMessages: null,
      viewMessageContent: false,
      showloadMoreButton: true,
      messageSubject: "",
      messageContent: "",
      messagType: "",
      pageNumber: 0,
      paginationSize: 5,
    };
  },
  created() {
    firestore
      .collection("MultimessageArchive")
      .doc(`${this.$hotelId}`)
      .get()
      .then((doc) => {
        this.fetchingDataLoader = false;
        if (doc.exists) {
          this.archivedMessages = doc.data().recentMultimessages;
          this.totalMultimessagesSent = doc.data().multimessageCount;
        } else {
          this.fetchingDataLoader = false;
        }
      });
  },
  computed: {
    pageCount() {
      let length = this.archivedMessages.length;
      let size = this.paginationSize;
      return Math.ceil(length / size);
    },
    paginatedData() {
      const start = this.pageNumber * this.paginationSize;
      const end = start + this.paginationSize;
      return this.archivedMessages.slice(start, end);
    },
    showPagination() {
      return this.archivedMessages.length > 5;
    },
  },
  methods: {
    openMessageContent(messageContent, messageSubject, messageType) {
      this.messageContent = messageContent;
      this.messageSubject = messageSubject;
      this.messagType = messageType;
      this.viewMessageContent = true;
    },
    selectFromArchive(
      messageToSelect,
      messageContent,
      messageSubject,
      messageType
    ) {
      if (messageToSelect === this.selectedMessage) {
        this.selectedMessage = null;
      } else {
        this.selectedMessage = messageToSelect;
        this.messageContent = messageContent;
        this.messageSubject = messageSubject;
        this.messagType = messageType;
      }
    },
    deletePermanently() {
      const messageToDelete = this.archivedMessages[this.selectedMessage - 1]
        .documentID;
      firestore
        .collection("MultimessageArchive")
        .doc(`${this.$hotelId}`)
        .collection("ArchivedMessages")
        .doc(messageToDelete)
        .delete()
        .then(() => {
          this.showApproveModal = false;
          this.closeArchive();
          this.$toastEvents.push({
            type: "copy",
            title: "Deletion",
            content: "Template has been deleted!",
            id: +new Date(),
          });
        })
        .catch((err) => console.log(err));
    },
    closeArchive() {
      this.selectedMessage = null;
      this.$emit("closeArchiveModal");
    },
    useFromArchive() {
      this.$emit("populateContent", {
        Type: this.messagType,
        Subject: this.messageSubject,
        Content: this.messageContent,
      });
    },
    loadAllLogs() {
      this.showloadMoreButton = false;
      this.fetchingDataLoader = true;
      firestore
        .collection("MultimessageArchive")
        .doc(`${this.$hotelId}`)
        .collection("ArchivedMessages")
        .orderBy("createdAt", "desc")
        .get()
        .then((querySnapshot) => {
          this.archivedMessages = [];
          this.fetchingDataLoader = false;
          querySnapshot.forEach((doc) => {
            this.archivedMessages.push(doc.data());
          });
        })
        .catch((err) => {
          this.fetchingDataLoader = false;
          console.log(err);
        });
    },
    nextPage() {
      this.pageNumber++;
    },
    prevPage() {
      this.pageNumber--;
    },
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}
h2,
p {
  color: #707070;
}
h2 {
  font-weight: 100;
  font-size: 26px;
  margin-bottom: 0;
}
.modalBackground {
  background-color: rgba(0, 0, 0, 0.8);
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.MessageArchive {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: white;
  width: 85vw;
  height: 90vh;
  border-radius: 5px;
  padding: 10px 25px;
}
.helperText {
  align-self: flex-start;
  margin-left: 20px;
  font-size: 18px;
}
.archiveList {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}
.listItem {
  display: flex;
  align-items: center;
}
.messageContent {
  flex-grow: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 5px 20px;
  padding: 10px 20px;
  background-color: white;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-wrap: wrap;
  transition: all 0.3s;
  cursor: pointer;
}
.messageContent p {
  margin-bottom: 0;
}
.messageContent > p:nth-child(1) {
  width: 60px;
}
.messageContent:hover {
  background-color: rgb(252, 252, 252);
}
.selectedBorder {
  background-color: #48b9ba;
  width: 20px;
  height: 70.4px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.2);
  margin-right: -20px;
}
.buttonRow,
.centerFlex {
  margin-bottom: 25px;
  display: flex;
  justify-content: center;
}
.pagination-bar-wrapper {
  margin: 15px 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.pagination-bar-inner-wrapper {
  margin: 0 20px;
  display: flex;
}
.pagination-item {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 2px solid #707070;
  margin: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.pagination-item-active {
  background-color: #707070;
  color: #ffffff;
}

@media screen and (max-width: 1025px) {
  h2 {
    font-size: 22px;
    margin-bottom: 0;
  }
  .listItem {
    margin: 3px 0;
  }
  .messageContent {
    margin: 2px;
    padding: 3px 20px;
  }
  .buttonRow {
    margin-bottom: 10px;
  }
}
@media screen and (max-width: 769px) {
  .messageContent__subject {
    display: none;
  }
}
</style>
